export default function initQuantitySelector(component, form) {
  if (form) {
    // INIT QUANTITY IF URL HAS A QUANTITY PARAM
    const quantityParameter = getUrlParameter("quantity");
    if (quantityParameter) {
      const input = form.querySelector('input[name="quantity"]');
      const max = input.max;
      input.value = Math.min(+quantityParameter, +max);
    }

    // INIT DOUBLE SELECTOR
    if (form.querySelector(".js-unit-capacity-value")) {
      import(/* webpackChunkName: "DoubleSelector" */"./quantitySelectors/_double.class.js").then(module => new module.DoubleSelector(form)).catch(console.error);
    }

    // INIT FLOORING SELECTOR
    if (form.querySelector(".js-floor-quantity")) {
      import(/* webpackChunkName: "FloorQuantity" */"./quantitySelectors/_flooring.class.js").then(module => new module.FloorQuantity(form)).catch(console.error);
    }

    // INIT BY QUANTITY SELECTOR
    const priceByQuantityEl = component.querySelector(".js-price-by-quantity");
    if (priceByQuantityEl) {
      import(/* webpackChunkName: "DoubleSelector" */"./quantitySelectors/_byQuantity.class.js").then(module => new module.ByQuantity(priceByQuantityEl, form)).catch(console.error);
    }
  }
}
function getUrlParameter(param, url = window.location.href) {
  param = param.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  let regex = new RegExp("[\\?&]" + param + "=([^&#]*)");
  let results = regex.exec(url);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}